import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "export" }
const _hoisted_2 = { class: "dialog-footer" }

import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { computed, ref } from 'vue';
import * as xlsx from 'xlsx';
import FileSaver from 'file-saver';
import dayjs from 'dayjs';


export default /*@__PURE__*/_defineComponent({
  __name: 'Export',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const pageStart = ref(1);
const pageEnd = ref(1);
const pageSize = ref(10);
const percentage = ref(0);
const apiName = ref('');
const apiFnc = ref('');
const params = ref<any>({});
const columns = ref<any[]>([]);
const lastPageSize = ref(10);
const lastPage = ref(1);

const total = computed(() => {
  if (Number(pageEnd.value) < Number(pageStart.value)) {
    return 0;
  }
  // 包含最后一页
  if (Number(pageEnd.value) === lastPage.value) {
    return (pageSize.value * (pageEnd.value - pageStart.value)) + lastPageSize.value;
  }
  return pageSize.value * (pageEnd.value - pageStart.value + 1);
});

const isStart = ref(false);
const waitStop = ref(false);


const getProgress = useBaseAsync(async() => {
  try {
    const datas: any = [];
    for (let i = 0; i <= pageEnd.value - pageStart.value; i++) {
      const res = await (useApi() as any)[apiName.value]?.[apiFnc.value]({
        ...params.value,
        pageQuery: {
          page: pageStart.value - 1 + i,
          pageSize: pageSize.value,
        },
      });
      if (waitStop.value) {
        isStart.value = false;
        visible.value = false;
        return;
      }
      datas.push(...(res.data?.data?.data || []));
      percentage.value = Math.floor(((i + 1) / (pageEnd.value - pageStart.value + 1)) * 90);
    }

    const worksheet = xlsx.utils.json_to_sheet(datas.map((item: any) => columns.value.reduce((res: any, current: any) => {
      if (!current.hideTable) {
        res[current.label] = current.render ? current.render({ row: item }) : item[current.name];
      }
      return res;
    }, {})));

    if (waitStop.value) {
      isStart.value = false;
      visible.value = false;
      return;
    }
    percentage.value = 95;
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Dates');
    const wbout = xlsx.write(workbook, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'array',
    });

    if (waitStop.value) {
      isStart.value = false;
      visible.value = false;
      return;
    }
    FileSaver.saveAs(
      new Blob([wbout], {
        type: 'application/octet-stream',
      }),
      `export_${dayjs().format('YYYY_MM_DD_HH_mm_ss')}.xlsx`,
    );
    percentage.value = 100;
    isStart.value = false;
    visible.value = false;
  } catch (error: any) {
    console.log('导出失败', error);
    ElMessage.error('导出失败');
    isStart.value = false;
  }
});

const handleClose = (done: () => void) => {
  if (isStart.value) {
    ElMessageBox.confirm('确认要停止导出吗？', '取消', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }).then(() => {
      waitStop.value = true;
    });
  } else {
    done();
  }
};


const start = useBaseAsync(() => {
  if (pageStart.value < 1 || pageStart.value > pageEnd.value) {
    ElMessage.error('请输入正确的页码，从1开始，结束页码不能小于开始页码');
    isStart.value = false;
    return;
  }
  isStart.value = true;
  getProgress();
});

__expose({
  show: (
    _apiName: string,
    _apiFnc: string,
    _params: any,
    _columns: any,
    _pageSize: number,
    _total: number,
  ) => {
    waitStop.value = false;
    percentage.value = 0;
    apiName.value = _apiName;
    apiFnc.value = _apiFnc;
    columns.value = _columns;
    visible.value = true;
    isStart.value = false;
    params.value = _params;
    pageStart.value = 1;
    pageSize.value = _pageSize;
    pageEnd.value = Math.ceil(_total / _pageSize);
    lastPage.value = pageEnd.value;
    lastPageSize.value = (_total % _pageSize) || _pageSize;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "导出",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    width: 710,
    "z-index": 1900,
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = () => handleClose(() => visible.value = false))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: isStart.value,
          onClick: _unref(start)
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode(" 确定 ")
          ])),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" 将导出从第 ")),
          _createVNode(_component_el_input_number, {
            modelValue: pageStart.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageStart).value = $event)),
            min: 1,
            max: lastPage.value
          }, null, 8, ["modelValue", "max"]),
          _cache[5] || (_cache[5] = _createTextVNode(" 页到第 ")),
          _createVNode(_component_el_input_number, {
            modelValue: pageEnd.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pageEnd).value = $event)),
            min: 1,
            max: lastPage.value
          }, null, 8, ["modelValue", "max"]),
          _createTextVNode(" 页的数据(共" + _toDisplayString(total.value) + "条) ", 1)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", null, " 数据越多耗时越长, 请先搜索后再导出，确认无误请点击确定 ", -1)),
        _createVNode(_component_el_progress, { percentage: percentage.value }, null, 8, ["percentage"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})